import { render, staticRenderFns } from "./TheTransporteurPage.vue?vue&type=template&id=0ca4046e&"
import script from "./TheTransporteurPage.vue?vue&type=script&lang=js&"
export * from "./TheTransporteurPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheTransporteurPage.vue"
export default component.exports